import { appConfig } from '_/config/app';

export const apiConfig = {
  apiUrl: appConfig.spaceManagement.spaceManagementApi,
  slackUrl: '',
  baseUrl: process.env.REACT_APP_API_URL || 'http://10.0.0.137:3030',
  apiTimeout: 20000,
};
